import {
  Box,
  Button,
  Checkbox,
  Flex,
  Group,
  Select,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core'

export const AccountOrganization = () => {
  return (
    <Flex p="md" gap={60} wrap="wrap">
      <Box>
        <Stack>
          <TextInput
            maw={450}
            size="md"
            label="Legal business name"
            defaultValue="PS 100 Alfred Nobel School"
            description="Contact support to make changes."
            disabled
          />
          <Select
            maw={450}
            size="md"
            label="Org type"
            data={[
              {
                label: 'School',
                value: 'SCHOOL',
              },
              {
                label: 'Childcare',
                value: 'CHILDCARE',
              },
              {
                label: 'Youth',
                value: 'YOUTH',
              },
              {
                label: 'Food',
                value: 'FOOD',
              },
              {
                label: 'Housing',
                value: 'HOUSING',
              },
              {
                label: 'Health',
                value: 'HEALTH',
              },
              {
                label: 'Legal',
                value: 'LEGAL',
              },
              {
                label: 'Work',
                value: 'WORK',
              },
              {
                label: 'Other',
                value: 'OTHER',
              },
            ]}
            value="SCHOOL"
            withAsterisk
          />
          <Select
            maw={450}
            size="md"
            label="Registered business address"
            data={[
              {
                label: 'United States',
                value: 'UNITED_STATES',
              },
            ]}
            value="UNITED_STATES"
          />
          <TextInput
            maw={450}
            size="md"
            placeholder="Address line 1"
            defaultValue="505 Park Avenue"
          />
          <TextInput
            maw={450}
            size="md"
            placeholder="Address line 2"
            defaultValue="Suite 1000"
            withAsterisk
          />
          <TextInput
            maw={450}
            size="md"
            placeholder="City"
            defaultValue="New York"
            withAsterisk
          />
          <Group>
            <Select
              maw={450}
              size="md"
              placeholder="State"
              data={[
                {
                  label: 'New York',
                  value: 'NEW_YORK',
                },
              ]}
              value="NEW_YORK"
            />
            <TextInput
              maw={450}
              size="md"
              placeholder="Zipcode"
              defaultValue="10010"
              withAsterisk
            />
          </Group>
          <Title order={4} mt="md">
            Security
          </Title>
          <Checkbox
            maw={450}
            label={
              <Text size="sm" c="dark" mt={2} fw="bold">
                Require 2-step verification for all staff.
              </Text>
            }
            description="This will require any staff member without 2-step verification to enable it the next time they sign in."
            checked
            disabled
          />
        </Stack>
      </Box>
      <Box style={{ flex: '1 1 auto' }}>
        <Title order={4} mb="lg">
          URLs
        </Title>
        <Stack>
          <TextInput
            maw={450}
            size="md"
            defaultValue="organization.com"
            description="Do not include “www.” unless required to access the site."
            label="Business website"
            withAsterisk
          />
          <TextInput
            maw={450}
            size="md"
            defaultValue="https://example.com/privacy-policy"
            label="Privacy policy"
            withAsterisk
          />
          <TextInput
            maw={450}
            size="md"
            defaultValue="https://example.com/terms-of-service"
            label="Terms of service"
            withAsterisk
          />
        </Stack>
        <Title order={4} mt="lg">
          Exemptions
        </Title>
        <Stack>
          <Select
            maw={450}
            size="md"
            data={[
              {
                label: 'Taxable',
                value: 'TAXABLE',
              },
              {
                label: 'Tax exempt',
                value: 'TAX_EXEMPT',
              },
            ]}
            value="TAXABLE"
            label="Sales tax exempt status"
          />
          <Select
            maw={450}
            size="md"
            data={[
              {
                label: 'Yes',
                value: 'YES',
              },
              {
                label: 'No',
                value: 'NO',
              },
            ]}
            placeholder="Select"
            label="Exempt organization certificate on file?"
          />
        </Stack>
        <Stack mt="sm" gap="xs" maw={450}>
          <Title order={4}>Close account</Title>
          <Text size="sm">
            WARNING: You will no longer be able to access any of your records or
            account information. Only an account representative with full access
            can close the account. Please be certain. This action cannot be
            undone.
          </Text>
          <Button color="red">Close Account</Button>
        </Stack>
        <Flex maw={450} mt="lg" justify="flex-end" gap="xs">
          <Button size="md" variant="default">
            Discard Changes
          </Button>
          <Button size="md">Save</Button>
        </Flex>
      </Box>
    </Flex>
  )
}
